import { createComponent } from '@carvana/merch-components';
import { forwardRef } from 'react';

type OwnProps = React.PropsWithoutRef<React.SVGProps<SVGSVGElement>>;

const ClockIcon = createComponent<OwnProps>('svg', {
  className: '-:text-grey-5'
});

export default forwardRef<SVGSVGElement, OwnProps>((props, ref) => (
  <ClockIcon
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <circle cx="8" cy="8" r="7" stroke="currentColor" strokeWidth="2" />
    <path
      d="M8 5.0387V9.24536L10.1078 10.525"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </ClockIcon>
));
